// extracted by mini-css-extract-plugin
export default {"app":"rootStyles_app__j6O-8"};